import React from "react";
import "./LandingPage.css";
import NavBar from "./components/NavBar";
import Bumpups from "./components/Bumpups";
import Timestamp from "./timestampcomp/Timestamp";
import Footer from "./components/Footer";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <NavBar />
      <div className="landing-card">
        <p className="landing-greeting">Hello landing page - we live</p>
        <Timestamp />
        <Bumpups />
        
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
